import React from "react";
import PropTypes from "prop-types";

const SizeFilterButton = ({ text, handleClick, showLabel }) => {
  return (
    <>
      {showLabel && (
        <label htmlFor="reviews-size-filter" className="eyebrow">
          Filter
        </label>
      )}
      <button
        id="reviews-size-filter"
        className="reviews_filters-size_filter-button"
        onClick={() => handleClick()}
        data-test-id="reviews_filters-size_filter">
        <span className="reviews_filters-size_filter-text" id="reviews_filters-size_filter-text">
          {text !== "Select Size" ? <label htmlFor="reviews_filters-size_filter-text">Sizes </label> : ""} {text}
        </span>
        <div className="reb-DownArrow"></div>
      </button>
    </>
  );
};

SizeFilterButton.propTypes = {
  text: PropTypes.string,
  handleClick: PropTypes.func,
  showLabel: PropTypes.bool,
};

export default SizeFilterButton;
